const cookiePolicy = [

  {
    id: 1,
    title: "1. Introduction",

    content: `
This Cookie Policy explains how Magyne ERP uses cookies
and similar technologies when you visit our websites, access our
applications, or use our cloud-based services.

Cookies help us provide a secure, reliable and personalized
experience while improving the performance of our platform.

By using Magyne services, you consent to the use of cookies as
described in this policy.
`
  },


  {
    id: 2,
    title: "2. What Are Cookies?",

    content: `
Cookies are small text files stored on your device when you visit
a website or use an online service.

Cookies allow websites to remember information about your visit,
such as your preferences, login sessions and usage patterns.

Cookies do not give us access to your device or personal files.
`
  },


  {
    id: 3,
    title: "3. How Magyne Uses Cookies",

    content: `
      Magyne uses cookies for several purposes including:
      • Maintaining secure user sessions.
      • Remembering user preferences.
      • Improving application performance.
      • Understanding how users interact with our platform.
      • Detecting suspicious activities and improving security.
      • Providing a better user experience across Magyne solutions.
    `
  },


  {
    id: 4,
    title: "4. Types of Cookies We Use",

    content: `
Essential Cookies

These cookies are required for the operation of Magyne services.
They support authentication, security features and core platform
functionality.

Without these cookies, some services may not function correctly.


Preference Cookies

These cookies remember choices you make, such as language,
display preferences and application settings.


Analytics Cookies

These cookies help us understand how users interact with our
services so that we can improve performance and usability.


Security Cookies

These cookies help protect accounts, prevent unauthorized access
and detect suspicious activities.
`
  },


  {
    id: 5,
    title: "5. Authentication and Session Cookies",

    content: `
Magyne uses secure authentication cookies and session technologies
to maintain user access and protect accounts.

These cookies may contain encrypted identifiers that allow the
platform to verify authenticated users.

We do not store passwords inside cookies.
`
  },


  {
    id: 6,
    title: "6. Third-Party Cookies",

    content: `
Some third-party services integrated with Magyne may place cookies
on your device.

These services may include:
• Payment providers.
• Analytics providers.
• Customer support tools.
• Cloud infrastructure providers.

Third parties manage their own cookies according to their privacy
policies.
`
  },


  {
    id: 7,
    title: "7. Managing Cookies",

    content: `
You can control or disable cookies through your browser settings.

You may choose to:
• Delete existing cookies.
• Block future cookies.
• Receive notifications before cookies are stored.

Please note that disabling certain cookies may affect the
functionality and security of Magyne services.
`
  },


  {
    id: 8,
    title: "8. Cookies and Personal Data",

    content: `
Some cookies may be associated with information that identifies
or relates to a user.

Any personal information collected through cookies is handled in
accordance with our Privacy Policy and applicable data protection
requirements.

We take appropriate measures to protect information collected
through cookies.
`
  },


  {
    id: 9,
    title: "9. Changes to This Cookie Policy",

    content: `
Magyne may update this Cookie Policy from time to time to reflect
changes in technology, legal requirements or our services.

Updated versions will be published on our website with the latest
effective date.
`
  },


  {
    id: 10,
    title: "10. Contact Us",

    content: `
If you have questions about this Cookie Policy or how Magyne uses
cookies, please contact our support team.

We are committed to maintaining transparency regarding how
technology is used to provide our services.
`
  }

];


export default cookiePolicy;